import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, RouteReuseStrategy, Router } from '@angular/router';
import { provideTransloco, translocoConfig } from '@jsverse/transloco';
import Aura from '@primeuix/themes/aura';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { apiEnvelopeInterceptor } from './app/core/api/api-envelope.interceptor';
import { apiContextInterceptor } from './app/core/api/api-context.interceptor';
import { authInterceptor } from './app/core/api/auth.interceptor';
import { TranslocoHttpLoader } from './app/core/localization/transloco-http-loader';
import { TabRouteReuseStrategy } from './app/layout/tab-route-reuse.strategy';
import { WorkflowModuleSurfaceRegistry } from './app/shared/workflow-surfaces/workflow-module-surface.registry';
import { registerAllWorkflowModuleSurfaces } from './app/shared/workflow-surfaces/workflow-surfaces.providers';

function initializeWorkflowSurfaces(registry: WorkflowModuleSurfaceRegistry, router: Router): () => void {
  return () => registerAllWorkflowModuleSurfaces(registry, router);
}

bootstrapApplication(AppComponent, {
  providers: [
    MessageService,
    provideAnimations(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      }
    }),
    { provide: RouteReuseStrategy, useClass: TabRouteReuseStrategy },
    provideRouter(routes),
    provideHttpClient(withInterceptors([apiContextInterceptor, authInterceptor, apiEnvelopeInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeWorkflowSurfaces,
      deps: [WorkflowModuleSurfaceRegistry, Router],
      multi: true
    },
    provideTransloco({
      config: translocoConfig({
        availableLangs: ['fa-IR', 'en-US'],
        defaultLang: 'fa-IR',
        fallbackLang: 'fa-IR',
        reRenderOnLangChange: true,
        prodMode: true
      }),
      loader: TranslocoHttpLoader
    })
  ]
}).catch(error => console.error(error));
